import { atomWithStorage } from 'jotai/utils'

import { tenantStore } from '../tenant-store'

export const SELECTED_DC_ID_LOCAL_STORAGE_KEY = 'selected_dc_id'

export const selectedDcIdAtom = atomWithStorage<number>(
  SELECTED_DC_ID_LOCAL_STORAGE_KEY,
  0,
  undefined,
  {
    // getOnInit を指定しておかないと初回ロード時にストレージの値でなく初期値を取得してしまう
    // see: https://byceclorets.com/next/jotai-atomwithstorage/
    getOnInit: true
  }
)

tenantStore.set(
  selectedDcIdAtom,
  Number(localStorage.getItem(SELECTED_DC_ID_LOCAL_STORAGE_KEY))
)

selectedDcIdAtom.debugLabel = 'selectedDcIdAtom'
